module.exports = __webpack_public_path__ + "static/media/dropwizard.782eef47.png";


//////////////////
// WEBPACK FOOTER
// ./src/Skillset/icon/dropwizard.png
// module id = 55
// module chunks = 0